import { restSlotPlain } from "./weekScheduleGrid";

/** Same cells the week table paints — column time, column title, slot content. */
export function cellsForWeekDay(weekGrid, dayName) {
  const day = (weekGrid?.days || []).find((d) => d.dayName === dayName) || null;
  return (weekGrid?.columns || [])
    .map((col) => {
      const slot = day?.byId?.[col.id];
      if (!slot && !col.added) return null;
      if (!slot && col.added) {
        return {
          colId: col.id,
          time: col.time || "",
          activity: col.activity || "Activity",
          content: restSlotPlain(col.activity) || String(col.notes || "").replace(/\\n/g, "\n"),
          row: null,
        };
      }
      const content =
        restSlotPlain(col.activity || slot.activity) ||
        String(slot.content ?? slot.row?.[3] ?? "").replace(/\\n/g, "\n");
      if (!content.trim() && !col.activity) return null;
      return {
        colId: col.id,
        time: col.time || slot.time || "",
        activity: col.activity || slot.activity || "",
        content,
        row: Array.isArray(slot.row) ? slot.row : null,
      };
    })
    .filter((cell) => cell && (String(cell.content || "").trim() || String(cell.activity || "").trim()));
}

export function origIndexForCell(cell, dayRows = []) {
  if (!cell?.row || !dayRows?.length) return -1;
  const exact = dayRows.findIndex((r) => r === cell.row);
  if (exact >= 0) return exact;
  const clock = String(cell.row[1] || "").trim();
  const title = String(cell.row[2] || "").trim();
  const snippet = String(cell.row[3] || "").replace(/\\n/g, "\n").slice(0, 80);
  return dayRows.findIndex((r) => {
    if (String(r[1] || "").trim() === clock && String(r[2] || "").trim() === title) return true;
    return snippet && String(r[3] || "").replace(/\\n/g, "\n").slice(0, 80) === snippet;
  });
}
